import {Component, Input, OnInit} from '@angular/core';
import {isNullOrUndefined} from 'util';
import {ApplicationContextService} from '../../../../core/services/impl/configuration/application-context.service';
import {currentYear} from '../../../utils/time-utils';
import {UrlIcon} from '../../../models/url-icon';
import {LabelValueItem} from '../../../models/label-value-item';
import {isCarOne, isKIOSKPOLIS, isNestBank} from '../../../../core/utils/utils';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  @Input() featuredProductsAllowed: boolean;

  footerTopBackgroundVisible: boolean = isKIOSKPOLIS() || isNestBank();
  footerTopBackgroundImageSrc: string = isNestBank() ? './assets/images/footer-top-background-nestbank.png' : './assets/images/footer-top-background.png';
  additionalLogo: string;
  phoneNumberIcon: string;
  emailIcon: string;

  data: FooterDataConfig = {
    phoneNumber: '+48 22 320 08 80',
    email: 'kontakt@kioskpolis.pl',
    landingPageUrlIcon: {
      url: 'https://kioskpolis.pl/',
      icon: './assets/images/logo/kioskpolis-white.svg'
    },
    socialMediaUrlIcons: [
      {
        url: 'https://www.instagram.com/kioskpolis.pl/',
        icon: './assets/images/icons/instagram.svg'
      },
      {
        url: 'https://www.facebook.com/KioskPolispl/',
        icon: './assets/images/icons/facebook.svg'
      },
      {
        url: 'https://www.linkedin.com/company/kioskpolis.pl/',
        icon: './assets/images/icons/linkedin.svg'
      }
    ],
    resources: [
      {
        label: 'FOOTER.RESOURCES.COOKIES',
        value: 'https://kioskpolis.pl/wp-content/uploads/Polityka-prywatnosci.pdf'
      },
      {
        label: 'FOOTER.RESOURCES.PRIVACY_POLICY',
        value: 'https://kioskpolis.pl/wp-content/uploads/Polityka-prywatnosci.pdf'
      }
    ]
  };
  isAgentContext: boolean;
  copyrightsTranslateParams = {
    currentYear: currentYear()
  };

  get featuredProductsVisible(): boolean {
    return this.featuredProductsAllowed && this.isAgentContext;
  }

  get headerVisible(): boolean {
    return !this.featuredProductsVisible;
  }

  get contentLpVisible(): boolean {
    return !this.featuredProductsVisible;
  }

  get resourcesVisible(): boolean {
    return !this.featuredProductsVisible;
  }

  get socialMediaVisible(): boolean {
    return !this.isAgentContext && (isKIOSKPOLIS() || isNestBank());
  }

  get copyrightsVisible(): boolean {
    return !isNullOrUndefined(this.data.copyrightsDisabled) ? !this.data.copyrightsDisabled : true;
  }

  constructor(private contextService: ApplicationContextService) { }

  ngOnInit(): void {
    this.initContactIcons();
    this.isAgentContext = this.contextService.isAgentContext;
    this.setAdditionalLogo();
  }

  private setAdditionalLogo(): void {
    if (isCarOne()) {
      this.additionalLogo = './assets/images/logo/car-one-logo-white.svg';
    }
  }

  private initContactIcons(): void {
    this.phoneNumberIcon = isNestBank() ? './assets/images/icons/violet-phone.svg' : './assets/images/icons/white-phone.svg';
    this.emailIcon = isNestBank() ? './assets/images/icons/violet-envelope.svg' : './assets/images/icons/white-envelope.svg';
  }

}

export interface FooterDataConfig {
  phoneNumber: string;
  email: string;
  landingPageUrlIcon: UrlIcon;
  socialMediaUrlIcons: UrlIcon[];
  resources: LabelValueItem[];
  copyrightsDisabled?: boolean; // default - false
}
